/*--------------------------------------------------------------------------*
 * スクロールバーの出し分け
 *--------------------------------------------------------------------------*/
module Module_MdlScrlbar {
	export class Model_MdlScrlbar {
		element: JQuery;
		scrlbarW: number;

		constructor(element?: JQuery) {
			this.element  = element ? element : $('[data-hide_scrl="element"]');
			this.scrlbarW = this.getScrollbarWidth();
		}

		// スクロールバーの幅を取得
		getScrollbarWidth(): number {
			let scrlbarWidth: number = window.innerWidth - $(window).width();
			if(scrlbarWidth === 0) {
				scrlbarWidth = 17;
			}
			return scrlbarWidth;
		}

		// 要素の幅を取得
		getElementW(element: JQuery): number[] {
			let elementW: number[] = new Array();
			element.each(function(i): void {
				const _self: JQuery = $(this);
				elementW.push(parseInt(_self.css("width")));
			});
			return elementW;
		}

		// 要素の右パッディングを取得
		getElementPaddingRight(element: any): number[] {
			let elementPaddingRight: number[] = new Array();
			element.each(function(i): void {
				const _self: JQuery = $(this);
				elementPaddingRight.push(parseInt(_self.css("padding-right")));
			});
			return elementPaddingRight;
		}

		// スクロールバーの出し分け処理
		changeScrlBarProp(): void {
			const view: this = this;
			view.element.each(function(i): void {
				const _self: JQuery = $(this),
					inner: JQuery = _self.find('[data-hide_scrl="inner"]'),
					elementChildren: JQuery = inner.children().length ? inner.children() : _self.children();
				let maxChildH: number = 0;

				elementChildren.not(":hidden").each(function(): void {
					const _selfH: number = $(this).height();
					if(_selfH > maxChildH) {
						maxChildH = _selfH;
					}
				});

				if(maxChildH > _self.innerHeight()) {
					// 表示
					if(inner.length) {
						inner.children().length > 0 ? inner.children().unwrap() : inner.remove();
					}
					_self.removeAttr("style");
				} else {
					// 非表示
					if(!inner.length) {
						_self.wrapInner('<div data-hide_scrl="inner" />');
					}
					view.initStyle(_self, i);
				}
			});
		}

		// 初期化
		changeScrlBarPropInit(): void {
			const view: this = this;
			view.element.each(function(i): void {
				const _self: JQuery = $(this),
					inner: JQuery = _self.find('[data-hide_scrl="inner"]');
				if(!inner.length) {
					_self.wrapInner('<div data-hide_scrl="inner" />');
				}
				view.initStyle(_self, i);
			})
		}

		// 初期スタイル
		initStyle(elm: any, i: number): void {
			const view: this = this,
				elementW: number[] = this.getElementW(this.element),
				elementPaddingRight: number[] = this.getElementPaddingRight(this.element);
			elm.css({overflow: "hidden visible"})
			.find('[data-hide_scrl="inner"]').css({
				paddingRight: elementPaddingRight[i] + this.scrlbarW,
				width: "calc("+elementW[i]+"px + "+this.scrlbarW+"px)",
				overflow: "hidden scroll",
			});
		}
	}
}
